import { Module } from '@nestjs/common';
import { IdProofsController } from './id-proofs.controller';
import { IdProofsService } from './id-proofs.service';

@Module({
  controllers: [IdProofsController],
  providers: [IdProofsService]
})
export class IdProofsModule {}
